import React from "react";

import TextInput from "../text-input";

export const PasswordInput: React.FC<React.ComponentProps<typeof TextInput>> = (
  props
) => <TextInput type="password" {...props} />;
export default PasswordInput;
